import React from "react";
import {
	Button,
	Text,
	Slider,
	SliderTrack,
	SliderFilledTrack,
	SliderThumb,
	Box,
	Checkbox,
	Tooltip,
} from "@chakra-ui/react";
import { textStyle, variant } from "theme/names";

export const Filter = ({
	type = "slider",
	title,
	prefix = "",
	sufix = "",
	max = 1000,
	min = 0,
	value,
	setValue,
	step = 100,
	isActive = false,
}) => {
	const getFilter = () => {
		if (type === "checkbox") {
			return (
				<>
					<Checkbox
						pt={3}
						isChecked={value}
						onChange={(e) => {
							setValue(e.target.checked);
						}}
					>
						{title}
					</Checkbox>
				</>
			);
		} else if (type === "button") {
			return (
				<Tooltip label={title}>
					<Button
						as="button"
						variant={
							isActive ? variant.Button.lightSelected : variant.Button.light
						}
						// height="40px"
						lineHeight="1.2"
						transition="all 0.2s cubic-bezier(.08,.52,.52,1)"
						px="4"
						fontSize="12px"
						onClick={() => setValue(value)}
						size="sm"
					>
						{title}
					</Button>
				</Tooltip>
			);
		} else
			return (
				<>
					<Box
						pt={5}
						width="100%"
						display="flex"
						justifyContent="space-between"
					>
						<Text textStyle={textStyle["body.medium.light"]} fontWeight="600">
							{title}
						</Text>
						<Text textStyle={textStyle["body.bold.standard"]}>
							{prefix + " " + value + (sufix ? " " + sufix : "")}
						</Text>
					</Box>
					<Slider
						mt={100}
						css={{ marginTop: "-10px" }}
						width="100%"
						max={max}
						min={min}
						step={step}
						// colorScheme="linkedin"
						aria-label={title}
						value={value}
						onChange={(val) => {
							setValue(val);
						}}
					>
						<SliderTrack>
							<SliderFilledTrack />
						</SliderTrack>
						<SliderThumb />
					</Slider>
				</>
			);
	};

	return <>{value !== null && setValue !== null && getFilter()}</>;
};